import { QuoteSearchResponse } from '@app/models/quote-search-response.model'
import { QuoteSessionStateModel } from './quote-session.state'
import { Contact } from '@app/models/contact'
import { Quote } from '@app/models/quote.model'
import { Nullable } from '@app/models/nullable'
import { ReferralAccount } from '@app/models/referral-account'
import { Pet } from '@app/models/pet.model'
import { BillingInformation } from '@app/models/billing-information'
import { ClaimsPayment } from '@app/models/claims-payment'
import { QuoteSession } from '@app/models/quote-session.model'

export enum QUOTE_SESSION_ACTIONS {
	CREATE_NEW = '[QuoteSession] Create New',
	NEW = '[QuoteSession] New',
	LOAD = '[QuoteSession] Load',
	LOAD_TAB_PROGRESS = '[QuoteSession] LoadTabProgress',
	UPDATE = '[QuoteSession] Update',
	UPSERT = '[QuoteSession] Upsert - DEPRECATED',
	SAVE = '[QuoteSession] Save',
	SAVE_SESSION = '[QuoteSession] Save Session',
	SAVE_FOR_CLOSE = '[QuoteSession] Save For Close',
	ACTIVATE_POLICY_QUOTE = '[QuoteSession] Activate Policy Quote',
	RETRIEVE_SESSION_BY_SEARCH_RESULT = '[QuoteSession] Retrieve by Search Result',
	LOAD_EXISTING_QUOTE = '[QuoteSession] Load Existing Quote',
	CLOSE_QUOTE = '[QuoteSession] Close Quote',
}

export namespace QuoteSessionAction {
	/** Creates a new empty session with a GUID from the api */
	export class CreateNew {
		static readonly type = QUOTE_SESSION_ACTIONS.CREATE_NEW
	}

	export class New {
		static readonly type = QUOTE_SESSION_ACTIONS.NEW
	}
	export class Load {
		static readonly type = QUOTE_SESSION_ACTIONS.LOAD
		constructor(public payload: QuoteSessionStateModel) {}
	}

	export class LoadTabProgress {
		static readonly type = QUOTE_SESSION_ACTIONS.LOAD_TAB_PROGRESS
		constructor(public payload: number) {}
	}

	export class Update {
		static readonly type = QUOTE_SESSION_ACTIONS.UPDATE
		constructor(public payload: Partial<QuoteSessionStateModel>) {}
	}

	/**
	 * @deprecated - use save session instead
	 */
	export class Upsert {
		static readonly type = QUOTE_SESSION_ACTIONS.UPSERT
	}

	export class Save {
		static readonly type = QUOTE_SESSION_ACTIONS.SAVE
		constructor(public payload: QuoteSessionStateModel) {}
	}

	export class SaveSession {
		static readonly type = QUOTE_SESSION_ACTIONS.SAVE_SESSION
	}

	export class SaveForClose {
		static readonly type = QUOTE_SESSION_ACTIONS.SAVE_FOR_CLOSE
	}

	export class ActivatePolicyQuote {
		static readonly type = QUOTE_SESSION_ACTIONS.ACTIVATE_POLICY_QUOTE
	}

	export class RetrieveSessionBySearchResult {
		static readonly type = QUOTE_SESSION_ACTIONS.RETRIEVE_SESSION_BY_SEARCH_RESULT
		constructor(public payload: QuoteSearchResponse) {}
	}

	export class LoadExistingQuote {
		static readonly type = QUOTE_SESSION_ACTIONS.LOAD_EXISTING_QUOTE
		constructor(public payload: QuoteSession) {}
	}

	export class CloseQuote {
		static readonly type = QUOTE_SESSION_ACTIONS.CLOSE_QUOTE
	}

	export class EmailQuote {
		static readonly type = '[QuoteSession] Email Quote'
	}

	export class PurchasePolicy {
		static readonly type = '[QuoteSession] Purchase Policy'
		constructor(
			public payload: {
				billing: Partial<BillingInformation>
				claimsPayment: Partial<ClaimsPayment>
			}
		) {}
	}

	export class Checkout {
		static readonly type = '[QuoteSession] Checkout'
		constructor() {}
	}

	export class Purchase {
		static readonly type = '[QuoteSession] Purchase'
		constructor(
			public payload: {
				contact: Contact
				claimsPayment: Partial<ClaimsPayment>
			}
		) {}
	}

	export namespace Contact {
		export class Update {
			static readonly type = '[QuoteSession.Contact] Update'
			constructor(public payload: Contact) {}
		}

		/** Gets the geographical state given the zip code */
		export class GetStateGivenZip {
			static readonly type = '[QuoteSession.Contact] Get State Given Zip'
			constructor(public payload: string = '') {}
		}

		export class ValidateAddress {
			static readonly type = '[QuoteSession.Contact] Validate Address'
			constructor(public payload: 'mailing' | 'billing' = 'mailing') {}
		}

		export class ValidateEmail {
			static readonly type = '[QuoteSession.Contact] Validate Email'
			constructor(public payload: string = '') {}
		}
	}

	export namespace Quote {
		export class Update {
			static readonly type = '[QuoteSession.Quote] Update'
			constructor(public payload: Partial<Quote>) {}
		}

		export class UpdateReferredAccount {
			static readonly type = '[QuoteSession.Quote] Update Referred Account'
			constructor(public payload: Nullable<ReferralAccount>) {}
		}

		export class ClearReferredAccount {
			static readonly type = '[QuoteSession.Quote] Clear Referred Account'
		}

		export class UpdateReferredSubAccount {
			static readonly type = '[QuoteSession.Quote] Update Referred SubAccount'
			constructor(public payload: Nullable<ReferralAccount>) {}
		}

		export class ClearReferredSubAccount {
			static readonly type = '[QuoteSession.Quote] Clear Referred SubAccount'
		}

		export class ResetStartDate {
			static readonly type = '[QuoteSession.Quote] Reset Start Date'
		}
	}

	export namespace Pets {
		export class Update {
			static readonly type = '[QuoteSession.Pets] Update'
			constructor(public payload: Pet[]) {}
		}

		export class ClearCoverages {
			static readonly type = '[QuoteSession.Pets] Clear Coverages'
		}
	}
}
